const ROUTE_MAP_PIP_RESTORE_STORAGE_KEY = "grain-saas:route-map-picture-in-picture-restore:v1";
const RESTORE_STATE_MAX_AGE_MS = 24 * 60 * 60 * 1000;
const STORAGE_VERSION = 1;

function resolveStorage(storage = null) {
  if (storage && typeof storage.getItem === "function" && typeof storage.setItem === "function") {
    return storage;
  }

  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.localStorage || null;
  } catch {
    return null;
  }
}

function normalizeText(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function readRouteMapPictureInPictureRestoreState(storage = null) {
  const resolvedStorage = resolveStorage(storage);
  if (!resolvedStorage) {
    return null;
  }

  try {
    const rawValue = resolvedStorage.getItem(ROUTE_MAP_PIP_RESTORE_STORAGE_KEY);
    if (!rawValue) {
      return null;
    }

    const parsedValue = JSON.parse(rawValue);
    if (!parsedValue || typeof parsedValue !== "object" || parsedValue.version !== STORAGE_VERSION) {
      return null;
    }

    const updatedAt = Number(parsedValue.updatedAt);
    if (!Number.isFinite(updatedAt) || Date.now() - updatedAt > RESTORE_STATE_MAX_AGE_MS) {
      resolvedStorage.removeItem(ROUTE_MAP_PIP_RESTORE_STORAGE_KEY);
      return null;
    }

    const scope = normalizeText(parsedValue.scope);
    if (!["fleet", "route"].includes(scope)) {
      return null;
    }

    return {
      assignmentId: normalizeText(parsedValue.assignmentId),
      scope,
      title: normalizeText(parsedValue.title),
      tripId: normalizeText(parsedValue.tripId),
      updatedAt,
    };
  } catch {
    return null;
  }
}

export function persistRouteMapPictureInPictureRestoreState(snapshot, storage = null) {
  const resolvedStorage = resolveStorage(storage);
  const scope = normalizeText(snapshot?.scope);
  if (!resolvedStorage || !["fleet", "route"].includes(scope)) {
    return null;
  }

  const nextSnapshot = {
    assignmentId: normalizeText(snapshot?.assignmentId),
    scope,
    title: normalizeText(snapshot?.title),
    tripId: normalizeText(snapshot?.tripId),
    updatedAt: Date.now(),
    version: STORAGE_VERSION,
  };

  try {
    resolvedStorage.setItem(ROUTE_MAP_PIP_RESTORE_STORAGE_KEY, JSON.stringify(nextSnapshot));
    return nextSnapshot;
  } catch {
    return null;
  }
}

export function clearRouteMapPictureInPictureRestoreState(storage = null) {
  const resolvedStorage = resolveStorage(storage);
  if (!resolvedStorage) {
    return;
  }

  try {
    resolvedStorage.removeItem(ROUTE_MAP_PIP_RESTORE_STORAGE_KEY);
  } catch {
    // Ignore storage failures in restricted browser contexts.
  }
}
